/**
 * Shared insights list for homepage and Insights listing page.
 * Each insight can have optional `detail` for the detail page (sections, cta, bottomImage).
 * detail shape: { sections: [ { heading, paragraphs: string[] } ], cta?: { heading, buttonText }, bottomImage?: { heading, image } }
 */

import chefarztRekrutierungInsightImage from "../assets/Images/insights/chefarzt-rekrutierung-insight.jpg";
import direktanspracheInsightImage from "../assets/Images/insights/direktansprache-insight.jpg";
import trends2026InsightImage from "../assets/Images/insights/trends-2026-insight.jpg";
import digitalFutureInsightImage from "../assets/Images/insights/digital-future-insight.jpg";
import aiRecruitmentInsightImage from "../assets/Images/insights/ai-recruitment-insight.jpg";
import directPatientInsightImage from "../assets/Images/insights/direct-patient-insight.jpg";
import costLeadershipInsightImage from "../assets/Images/insights/cost-leadership-insight.jpg";
import nachfolgeplanungInsightImage from "../assets/Images/insights/nachfolgeplanung-insight.jpg";
export const INSIGHTS_LIST = [
  {
    id: "1",
    slug: "chefarzt-rekrutierung",
    topic: "Recruiting im Gesundheitswesen",
    type: "ARTICLE",
    date: "24. Februar 2026",
    title: "Fachkräftemangel im Gesundheitswesen und seine Lösungen",
    description:
      "Der Wettbewerb um qualifizierte Fachärzte wächst stetig. Neue Recruiting-Strategien helfen Kliniken und Unternehmen, die richtigen Spezialisten zu gewinnen.",
    image: chefarztRekrutierungInsightImage,
    to: "/medical/insights/chefarzt-rekrutierung",
    detail: {
      sections: [
        {
          heading: "Fachkräftemangel im Gesundheitswesen und seine Lösungen",
          paragraphs: [
            "Der Wettbewerb um qualifizierte Fachärzte wächst stetig. Neue Recruiting-Strategien helfen Kliniken und Unternehmen, die richtigen Spezialisten zu gewinnen.",
            "Kliniken und Gesundheitseinrichtungen stehen vor der Herausforderung, Chefarztpositionen und andere Schlüsselrollen zeitnah und passgenau zu besetzen. Eine gezielte Direktansprache und langfristige Beziehungspflege mit potenziellen Kandidaten werden dabei immer wichtiger.",
          ],
        },
        {
          heading: "Was wir für Sie tun können",
          paragraphs: [
            "REPEXO Medical unterstützt Kliniken und Unternehmen bei der Identifikation und Gewinnung von Fach- und Führungskräften. Mit unserer Erfahrung im Healthcare-Recruiting und unserem branchenweiten Netzwerk finden wir die passenden Kandidaten für Ihre Anforderungen.",
          ],
        },
      ],
      cta: {
        heading: "Sie suchen qualifizierte Fach- oder Führungskräfte?",
        buttonText: "Nehmen Sie Kontakt mit uns auf",
      },
    },
  },
  {
    id: "2",
    slug: "direktansprache",
    topic: "Direktansprache",
    type: "ARTICLE",
    date: "21. Januar 2026",
    title: "Warum Direktansprache im Healthcare Recruiting wichtig ist",
    description:
      "Viele Top-Kandidaten sind nicht aktiv auf Jobsuche. Durch Direktansprache können Unternehmen diese Talente gezielt erreichen.",
    image: direktanspracheInsightImage,
    to: "/medical/insights/direktansprache",
    detail: {
      sections: [
        {
          heading: "Warum Direktansprache im Healthcare Recruiting wichtig ist",
          paragraphs: [
            "Viele Top-Kandidaten sind nicht aktiv auf Jobsuche. Durch Direktansprache können Unternehmen diese Talente gezielt erreichen.",
            "Im verdeckten Arbeitsmarkt befinden sich oft die besten Köpfe: erfahrene Ärztinnen und Ärzte, Führungskräfte und Spezialisten, die nicht auf klassischen Jobportalen aktiv sind. Headhunting und Direktansprache ermöglichen es, diese Kandidaten diskret und zielgerichtet anzusprechen.",
          ],
        },
        {
          heading: "Unsere Methode",
          paragraphs: [
            "REPEXO Medical setzt auf strukturierte Direktansprache und Executive Search im Gesundheitswesen. Wir kombinieren Branchenkenntnis, ein starkes Netzwerk und ethische Standards, um Mandanten und Kandidaten erfolgreich zusammenzubringen.",
          ],
        },
      ],
      cta: {
        heading: "Interesse an Direktansprache für Ihre Vakanzen?",
        buttonText: "Kontakt aufnehmen",
      },
    },
  },
  {
    id: "3",
    slug: "trends-2026",
    topic: "Medizinbranche",
    type: "ARTICLE",
    date: "05. Januar 2026",
    title: "Recruiting Trends im Healthcare Markt 2026",
    description:
      "Der Gesundheitsmarkt verändert sich schnell. Moderne Recruiting-Methoden helfen Unternehmen, Fachkräfte langfristig zu gewinnen.",
    image: trends2026InsightImage,
    to: "/medical/insights/trends-2026",
    detail: {
      sections: [
        {
          heading: "Recruiting Trends im Healthcare Markt 2026",
          paragraphs: [
            "Der Gesundheitsmarkt verändert sich schnell. Moderne Recruiting-Methoden helfen Unternehmen, Fachkräfte langfristig zu gewinnen.",
            "Digitalisierung, demografischer Wandel und der Kampf um Talente prägen das Recruiting im Gesundheitswesen. Kliniken und Anbieter setzen zunehmend auf Employer Branding, agile Prozesse und gezielte Direktansprache, um Fach- und Führungskräfte zu binden.",
          ],
        },
        {
          heading: "Ausblick",
          paragraphs: [
            "Wer frühzeitig in Beziehungen zu potenziellen Kandidaten investiert und Recruiting als strategische Aufgabe versteht, wird auch 2026 und darüber hinaus im Wettbewerb um die besten Köpfe bestehen.",
          ],
        },
      ],
      cta: {
        buttonText: "Beratung anfragen",
      },
    },
  },
  {
    id: "4",
    slug: "digital-future",
    topic: "Künstliche Intelligenz",
    type: "ARTICLE",
    date: "01. März 2026",
    title: "Die digital geprägte Zukunft des Gesundheitswesens",
    description:
      "Wie KI und digitale Werkzeuge Diagnostik, Behandlung und Patientenerlebnis in Gesundheitseinrichtungen transformieren.",
    image: digitalFutureInsightImage,
    to: "/medical/insights/digital-future",
    detail: {
      sections: [
        {
          heading: "Die digital geprägte Zukunft des Gesundheitswesens",
          paragraphs: [
            "Wie KI und digitale Werkzeuge Diagnostik, Behandlung und Patientenerlebnis in Gesundheitseinrichtungen transformieren.",
            "Gesundheitseinrichtungen setzen zunehmend auf digitale Strategien, um Effizienz, Behandlungsergebnisse und die Zufriedenheit der Mitarbeitenden zu verbessern. Führungskräfte, die klinische Expertise mit digitalen und operativen Kompetenzen verbinden, sind stark gefragt.",
          ],
        },
        {
          heading: "Auswirkungen auf die Personalgewinnung",
          paragraphs: [
            "Die Besetzung von Führungs- und Spezialistenrollen im Gesundheitswesen erfordert heute häufig Kandidatinnen und Kandidaten, die neben klinischem oder operativem Hintergrund auch mit Daten, Technologie und neuen Versorgungsmodellen sicher umgehen.",
          ],
        },
      ],
      cta: {
        buttonText: "Kontakt aufnehmen",
      },
    },
  },
  {
    id: "5",
    slug: "ai-recruitment",
    topic: "Künstliche Intelligenz",
    type: "ARTICLE",
    date: "15. Februar 2026",
    title: "KI im medizinischen Recruiting: Passende Talente schneller finden",
    description:
      "Wie künstliche Intelligenz Gesundheitseinrichtungen mit qualifizierten Kandidatinnen und Kandidaten zusammenbringt und den Einstellungsprozess effizienter macht.",
    image: aiRecruitmentInsightImage,
    to: "/medical/insights/ai-recruitment",
    detail: {
      sections: [
        {
          heading: "KI im medizinischen Recruiting: Passende Talente schneller finden",
          paragraphs: [
            "Wie künstliche Intelligenz Gesundheitseinrichtungen mit qualifizierten Kandidatinnen und Kandidaten zusammenbringt und den Einstellungsprozess effizienter macht.",
            "KI kann beim Screening, bei der Terminplanung und bei ersten Einschätzungen unterstützen. Der menschliche Faktor bleibt jedoch entscheidend, um Vertrauen aufzubauen, kulturelle Passung zu bewerten und mit Top-Talenten zu verhandeln. Die besten Ergebnisse entstehen aus der Kombination von Technologie und erfahrener Personalberatung.",
          ],
        },
        {
          heading: "So arbeiten wir",
          paragraphs: [
            "REPEXO Medical kombiniert datenbasierte Ansätze mit fundierter Branchenkenntnis und einer beziehungsorientierten Vorgehensweise in Executive Search und Direktansprache im Gesundheitswesen.",
          ],
        },
      ],
      cta: {
        buttonText: "Kontakt aufnehmen",
      },
    },
  },
  {
    id: "6",
    slug: "direct-patient",
    topic: "Kostenmanagement",
    type: "ARTICLE",
    date: "10. Februar 2026",
    title: "Die direkte Zukunft der Patientenversorgung im Gesundheitswesen",
    description:
      "Value-based-Care- und Kostenmanagement-Strategien, mit denen Anbieter bessere Ergebnisse erzielen und gleichzeitig Kosten steuern.",
    image: directPatientInsightImage,
    to: "/medical/insights/direct-patient",
    detail: {
      sections: [
        {
          heading: "Die direkte Zukunft der Patientenversorgung im Gesundheitswesen",
          paragraphs: [
            "Value-based-Care- und Kostenmanagement-Strategien, mit denen Anbieter bessere Ergebnisse erzielen und gleichzeitig Kosten steuern.",
            "Da sich die Versorgung in Richtung wertbasierter und patientenzentrierter Modelle entwickelt, müssen Führungsteams klinische Qualität, Kostenkontrolle und Personalplanung ausbalancieren. Die Gewinnung von Führungskräften, die diese Dynamik verstehen, ist entscheidend für langfristigen Erfolg.",
          ],
        },
        {
          heading: "Recruiting von Führungskräften",
          paragraphs: [
            "Wir unterstützen Gesundheitseinrichtungen dabei, Führungskräfte und Spezialistinnen bzw. Spezialisten zu finden, die wertbasierte Initiativen und operative Exzellenz in einem dynamischen Umfeld vorantreiben.",
          ],
        },
      ],
      cta: {
        buttonText: "Mit unserem Team sprechen",
      },
    },
  },
  {
    id: "7",
    slug: "cost-leadership",
    topic: "Kostenmanagement",
    type: "ARTICLE",
    date: "28. Januar 2026",
    title: "Kostenmanagement bei der Gewinnung von Krankenhaus-Führungskräften",
    description:
      "Wie Budgetvorgaben mit dem Bedarf in Einklang gebracht werden, Top-Führungskräfte im Gesundheitswesen zu gewinnen und zu halten.",
    image: costLeadershipInsightImage,
    to: "/medical/insights/cost-leadership",
    detail: {
      sections: [
        {
          heading: "Kostenmanagement bei der Gewinnung von Krankenhaus-Führungskräften",
          paragraphs: [
            "Wie Budgetvorgaben mit dem Bedarf in Einklang gebracht werden, Top-Führungskräfte im Gesundheitswesen zu gewinnen und zu halten.",
            "Krankenhäuser und Gesundheitssysteme müssen in starke Führung investieren und gleichzeitig Kosten steuern. Effektive Recruiting-Strategien - darunter klare Rollenprofile, eine wettbewerbsfähige Positionierung und effiziente Prozesse - helfen dabei, passende Kandidatinnen und Kandidaten im Budget- und Zeitrahmen zu gewinnen.",
          ],
        },
        {
          heading: "Unser Ansatz",
          paragraphs: [
            "Wir arbeiten mit unseren Mandanten daran, Anforderungen klar zu definieren, den Markt zu analysieren und eine gezielte Suche sowie Bewertung umzusetzen, damit Recruiting echten Mehrwert liefert und das Risiko von Fehlbesetzungen reduziert.",
          ],
        },
      ],
      cta: {
        buttonText: "Kontakt aufnehmen",
      },
    },
  },
  {
    id: "8",
    slug: "nachfolgeplanung",
    topic: "Recruiting im Gesundheitswesen",
    type: "ARTICLE",
    date: "12. Januar 2026",
    title: "Nachfolgeplanung in Kliniken: Best Practices",
    description:
      "Erfolgreiche Nachfolgeregelung für Führungspositionen im Gesundheitswesen durch strukturierte Prozesse.",
    image: nachfolgeplanungInsightImage,
    to: "/medical/insights/nachfolgeplanung",
    detail: {
      sections: [
        {
          heading: "Nachfolgeplanung in Kliniken: Best Practices",
          paragraphs: [
            "Erfolgreiche Nachfolgeregelung für Führungspositionen im Gesundheitswesen durch strukturierte Prozesse.",
            "Ob Chefarzt, Ärztliche Direktion oder Leitung einer Abteilung: Eine frühzeitige und systematische Nachfolgeplanung vermeidet Wissensverlust und sichert die Kontinuität der Versorgung. Dazu gehören klare Anforderungsprofile, interne und externe Kandidatensuche sowie eine geplante Übergabe.",
          ],
        },
        {
          heading: "Wie wir unterstützen",
          paragraphs: [
            "REPEXO Medical begleitet Kliniken und Einrichtungen bei der Nachfolgeplanung: von der Profilierung der Rolle über die Suche nach passenden Kandidaten bis zur Einarbeitung und Übergabe.",
          ],
        },
      ],
      cta: {
        heading: "Nachfolge anstehend?",
        buttonText: "Unverbindlich beraten lassen",
      },
    },
  },
];

/** Return insights with links under the given base path (e.g. "/medical" or "/sales"). */
export function getInsightsList(basePath = "/medical") {
  const prefix = basePath.replace(/\/$/, "") + "/insights";
  return INSIGHTS_LIST.map((item) => ({
    ...item,
    to: `${prefix}/${item.slug}`,
  }));
}

// Unique topics with counts (derived from INSIGHTS_LIST)
export function getTopicsWithCounts() {
  const counts = {};
  INSIGHTS_LIST.forEach((item) => {
    counts[item.topic] = (counts[item.topic] || 0) + 1;
  });
  return Object.entries(counts).map(([topic, count]) => ({ topic, count }));
}

/** Get insight by URL slug (e.g. from /medical/insights/:slug) */
export function getInsightBySlug(slug) {
  return INSIGHTS_LIST.find((item) => item.slug === slug) ?? INSIGHTS_LIST.find((item) => item.to.endsWith(`/${slug}`)) ?? null;
}

